import { Directive, TemplateRef } from '@angular/core';

import { SituacaoConfirmacaoService } from './situacao-confirmacao.service'

/**
 * Diretiva que permite recuperar a referência para o template que contém o modal
 * e armazena o estado no serviço interno. A aplicação deverá declarar o template 
 * conforme exemplo abaixo
 * 
 * ```
 * <template confirmacao>
 *   <confirm-modal-component></confirm-modal-component>
 * </template>
 * ```
 */
@Directive({
  selector: "[confirmacao]"
})
export class ConfirmacaoTemplateDirective 
{
    constructor(confirmacaoTemplate: TemplateRef<any>, state: SituacaoConfirmacaoService) 
    {
        state.template = confirmacaoTemplate;
    }
}